/*
|--------------------------------------------------------------------------
| 共通
|--------------------------------------------------------------------------|
*/
import { useAuthStore } from "@/stores/AuthStore";
import { createRouter, createWebHistory } from "vue-router";

// ログイン周り
import authRoute from "@/router/common/_auth";
// 管理画面セレクト
import mgmtSelectRoute from "@/router/common/_mgmtSelect";
/*
|--------------------------------------------------------------------------
| KIZUNA
|--------------------------------------------------------------------------|
*/

/*
|--------------------------------------------------------------------------
| KIZUNA 特定技能
|--------------------------------------------------------------------------|
*/

/*
|--------------------------------------------------------------------------
| 営業
|--------------------------------------------------------------------------|
*/
// 顧客管理
import companiesRoute from "@/router/sales/_companies";

/*
|--------------------------------------------------------------------------
| ルーターの設定
|--------------------------------------------------------------------------|
*/
export const routes = [
	...authRoute,
	...mgmtSelectRoute,
	...companiesRoute
	// ...addressRoute,
	// ...uploadRoute,
	// ...downloadRoute,
	// ...logRoute,
	// ...paymentRoute,
	// ...accountRoute,
	// ...memberRoute,
	// ...errorRoute
];

// ルーターの動作を設定
const router = createRouter({
	// アプリケーションのURLルートを指定
	history: createWebHistory(import.meta.env.APP_URL),
	// ページ遷移時にスクロール位置を設定する
	scrollBehavior(to, from, savedPosition) {
		return { top: 0 };
	},
	routes
});

// ページ遷移前に行う処理を定義
router.beforeEach((to, from, next) => {
	const auth = useAuthStore();
	const isAuthenticated = auth.isAuthenticated;

	const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

	console.log("ddd");

	if (requiresAuth && !isAuthenticated) {
		next("/signin");
	} else {
		document.title = to.meta.title;
		next();
	}
});
export default router;
